import { render, staticRenderFns } from "./BgmView.vue?vue&type=template&id=d8311512&scoped=true"
import script from "./BgmView.vue?vue&type=script&lang=js"
export * from "./BgmView.vue?vue&type=script&lang=js"
import style0 from "./BgmView.vue?vue&type=style&index=0&id=d8311512&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8311512",
  null
  
)

export default component.exports